import { Loader2, AlertTriangle } from 'lucide-react';

interface AdminTabShellProps {
  isLoading: boolean;
  error: Error | null;
  children: React.ReactNode;
}

export function AdminTabShell({ isLoading, error, children }: AdminTabShellProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-16">
        <Loader2 className="h-6 w-6 animate-spin text-wt-text-muted" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center gap-2 py-16 justify-center text-wt-red-primary">
        <AlertTriangle className="h-5 w-5" />
        <span className="text-sm">Failed to load: {error.message}</span>
      </div>
    );
  }

  return <>{children}</>;
}
